import { CompanyType, VisitMode } from "@/types";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useRouterStore } from "@/store/zustandStore";
import { useEffect } from "react";

const PageComponent = () => {
  const initialized = useRouterStore((state) => state.initialized);
  const user = useRouterStore((state) => state.user);
  const company = useRouterStore((state) => state.company);
  const building = useRouterStore((state) => state.building);
  const dashBoardEnabled = useRouterStore((state) => state.dashBoardEnabled);
  const handbookLink = useRouterStore((state) => state.handbookLink);
  const navigate = useNavigate();

  useEffect(() => {
    // The router store is filled asynchronously by BuildingUserProvider. Until
    // that happens every check below reads its default value and we would fall
    // all the way through to /settings.
    if (!initialized) return;

    const companyHasVisitEnabled = company?.visitMode === VisitMode.ENABLED;
    const buildingHasWelcomeVisit = building?.enableWelcomeVisit;

    if (company && company.companyType === CompanyType.EXTERNAL) {
      navigate({ to: "/bookings" });
      return;
    }
    if (dashBoardEnabled) {
      navigate({ to: "/dashboard" });
      return;
    }
    if (companyHasVisitEnabled && buildingHasWelcomeVisit) {
      navigate({ to: "/visitors" });
      return;
    } else if (handbookLink) {
      navigate({ to: "/handbook" });
      return;
    } else if (user?.adminInCompanies.length > 0) {
      navigate({
        to: "/company/$companyId/users",
        params: {
          companyId: company.buildingTenantId,
        },
      });
      return;
    } else {
      navigate({ to: "/settings" });
      return;
    }
  }, [
    initialized,
    user,
    company,
    building,
    dashBoardEnabled,
    handbookLink,
    navigate,
  ]);
  return <></>;
};

export const Route = createFileRoute("/_portal/")({
  component: PageComponent,
});
